import React, { useEffect, useState } from "react";
import { API } from "@/lib/api";

// Loads a protected file as a blob (cookies sent automatically) and renders it.
export function FileImage({ fileId, alt = "", className = "", ...props }) {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let revoked = false;
    let objUrl;
    (async () => {
      try {
        const res = await fetch(`${API}/files/${fileId}`, { credentials: "include" });
        if (!res.ok) throw new Error("failed");
        const blob = await res.blob();
        objUrl = URL.createObjectURL(blob);
        if (!revoked) setUrl(objUrl);
      } catch {
        setErr(true);
      }
    })();
    return () => {
      revoked = true;
      if (objUrl) URL.revokeObjectURL(objUrl);
    };
  }, [fileId]);

  if (err)
    return (
      <div className={`flex items-center justify-center bg-slate-100 text-slate-400 text-xs ${className}`}>
        No image
      </div>
    );
  if (!url)
    return <div className={`animate-pulse bg-slate-200 ${className}`} />;
  return <img src={url} alt={alt} className={className} {...props} />;
}
